import { Component, EventEmitter, Input, Output, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ContextService } from '../../context.service';
import { findReminderWhatsAppTemplate, resolveReminderWhatsAppTemplateKey } from '../../smsSettings/whatsapp/whatsapp-reminder-template';
import { WhatsAppTemplate, WhatsAppTemplatesService } from '../../smsSettings/whatsapp/whatsapp-templates.service';

/** WhatsApp channel of a reminder definition: on/off switch plus a read-only view of its message. */
@Component({
  selector: 'app-whatsapp-reminder-tab',
  templateUrl: './whatsapp-reminder-tab.component.html',
  styleUrls: ['./whatsapp-reminder-tab.component.scss']
})
export class WhatsAppReminderTabComponent implements OnInit, OnChanges, OnDestroy {

  @Input() reminderType: string;
  @Input() enabled = false;
  /** True when WhatsApp sending is turned off for the business (v3 locks the toggle). */
  @Input() locked = false;
  @Output() enabledChange = new EventEmitter<boolean>();

  template: WhatsAppTemplate | undefined;

  /** Until Meta approves the template, messaging sends the reminder by SMS instead. */
  get isAwaitingApproval(): boolean {
    return !!this.template && this.template.status !== 'APPROVED';
  }
  loading = false;
  loadError = false;

  private contextSub: Subscription;
  private loadSub: Subscription;
  private contextIdDto: { contextId?: string; contextIdType?: string };

  constructor(private contextService: ContextService, private templatesApi: WhatsAppTemplatesService) { }

  ngOnInit() {
    this.contextSub = this.contextService.contextIdDto$.subscribe(contextIdDto => {
      this.contextIdDto = contextIdDto;
      this.load();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['reminderType'] && !changes['reminderType'].firstChange) {
      this.load();
    }
  }

  ngOnDestroy() {
    this.contextSub?.unsubscribe();
    this.loadSub?.unsubscribe();
  }

  load() {
    const templateKey = resolveReminderWhatsAppTemplateKey(this.reminderType);
    if (!templateKey || !this.contextIdDto?.contextId) {
      return;
    }
    this.loadSub?.unsubscribe();
    this.loading = true;
    this.loadError = false;
    this.loadSub = this.templatesApi.getTemplates(this.contextIdDto.contextId, this.contextIdDto.contextIdType)
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        templates => this.template = findReminderWhatsAppTemplate(templates, templateKey),
        () => this.loadError = true);
  }
}
